export enum StorageKey {
	ACCESS_TOKEN_KEY = 'access_token',
	REFRESH_TOKEN_KEY = 'refresh_token',
	AVATAR_URL = 'avatar_url',
	LOGIN_TYPE = 'login_type',
	ROLE_TYPE = 'user_role',
	USERNAME = 'username',
	USERID = 'userId',
	EXTERNAL_USER_ID = 'externalId',
	USER_COUNTY = 'user_county'
}
